import {
  BooleanField,
  CreateButton,
  Datagrid,
  List,
  NumberField,
  TextField,
  TopToolbar,
} from 'react-admin';

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

export function TemplateList() {
  return (
    <List actions={<ListActions />} sort={{ field: 'name', order: 'ASC' }} perPage={50}>
      <Datagrid rowClick="edit">
        <TextField source="name" />
        <TextField source="slug" />
        <NumberField source="version" />
        <BooleanField source="is_active" label="Active" />
      </Datagrid>
    </List>
  );
}
